import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux';

import { formatDateLocal } from '../../../../lib/script'
import Button from '../../../common/Button'
import Tag from '../../../fragments/Tag'
import { notePriorityOptions, noteTypesOptions } from '../../../../lib/systemData';
import DaysDifference from './DaysDifference'
import TaskMessages from '../../../tasks/TaskMessages'
import TaskAssignee from '../../../tasks/TaskAssignee'
import ResolveAndCreate from './ResolveAndCreate';
import BodySimpleModalV2 from '../../../common/modal/BodySimpleModalV2';
import DeleteNote, { DeletedNoteMeta } from './DeleteNote';
import { isDeletedRecord } from '../../../../lib/noteDelete';

import classes from './NotesItem.module.css'

const NotesItem = ({itemData, caseData}) => {
    const [showResolveTask, setShowResolveTask] = useState(false)
    const [copyMessageText, setCopyMessageText] = useState('Copy to clipboard.')
    const user = useSelector(state => state.user.user)
    const noteTypes = useMemo(() => noteTypesOptions() || [], [])
    const notePriorities = useMemo(() => notePriorityOptions() || [], [])
    const noteType = useMemo(() => noteTypes.find((item) => item.value === itemData.note_type_id), [noteTypes, itemData.note_type_id])
    const actionType = useMemo(() => noteType?.note_actions?.find((item) => item.id === itemData.note_action_id), [noteType, itemData.note_action_id])
    const priorityColor = useMemo(() => notePriorities.find((item) => item.value === itemData.priority)?.color, [notePriorities, itemData.priority])


    function openResolveTask() {
        setShowResolveTask(prevState => !prevState)
    }

    async function copyTaskMessageHandler() {
        const plainLines = []
        const htmlLines = []

        if (itemData?.note) {
            plainLines.push(itemData.note)
            htmlLines.push(`${itemData.note}`)
        }

        if (itemData?.assignee_resolved_note) {
            const resolvedByLine = `Resolved by ${itemData?.assignee_resolved_by?.name || ''} with note ${itemData.assignee_resolved_note}`.trim()
            plainLines.push(resolvedByLine)
            htmlLines.push(`<strong>Resolved by</strong> ${itemData?.assignee_resolved_by?.name || ''} <strong>with note</strong> ${itemData.assignee_resolved_note}`)
        }

        if (itemData?.resolved_note) {
            plainLines.push(`Resolved Message ${itemData.resolved_note}`)
            htmlLines.push(`<strong>Resolved Message</strong> ${itemData.resolved_note}`)
        }

        const messageToCopy = plainLines.join('\n')
        if (!messageToCopy || !navigator?.clipboard?.writeText) {
            setCopyMessageText('Unable to copy')
            setTimeout(() => {
                setCopyMessageText('Copy to clipboard.')
            }, 1000)
            return
        }
        try {
            if (navigator?.clipboard?.write && window?.ClipboardItem) {
                const htmlToCopy = htmlLines.join('<br/>')
                const clipboardItem = new window.ClipboardItem({
                    'text/plain': new Blob([String(messageToCopy)], { type: 'text/plain' }),
                    'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
                })
                await navigator.clipboard.write([clipboardItem])
            } else {
                await navigator.clipboard.writeText(String(messageToCopy))
            }
            setCopyMessageText('Copied')
            setTimeout(() => {
                setCopyMessageText('Copy to clipboard.')
            }, 600)
        } catch (error) {
            setCopyMessageText('Copy failed')
            setTimeout(() => {
                setCopyMessageText('Copy to clipboard.')
            }, 1000)
        }
    }

    const deletedRecord = isDeletedRecord(itemData)
    const showResolve = !deletedRecord && itemData.is_task && !itemData.assignee_resolved && !itemData.resolved
    const showComplete = !deletedRecord && itemData.is_task && itemData.user?.id == user?.id && itemData.assignee_resolved && !itemData.resolved
    const showResolvedInfo = Boolean(!deletedRecord && itemData.is_task && (itemData.assignee_resolved || itemData.resolved) && !showResolve && !showComplete)

    return <>
        <tr className={`${deletedRecord ? classes.deleted_row : ''} ${!deletedRecord && itemData.note_action ? classes.action_row : ''} ${!deletedRecord && (itemData.assignee_resolved || itemData.resolved) ? classes.item_resolved : ''}`}>
            <td>{itemData.created_at && <>{formatDateLocal(itemData.created_at)}</>}</td>
            <td style={{width: 130}}>{itemData.user ? itemData.user.name : 'System'}</td>
            <td>{itemData.note_type_id && noteType?.label}</td>
            <td className={classes.notes_cell_td}>
                <div className={classes.notes_cell}>
                    <TaskMessages itemData={itemData} classes={classes}/>
                    {deletedRecord && <DeletedNoteMeta itemData={itemData} />}
                </div>
            </td>
            <td><Tag type={(itemData.is_task === 0) || itemData.is_task === false ? 'note' : 'task'}>{(itemData.is_task === 0) || itemData.is_task === false ? 'note' : 'task'}</Tag></td>
            <td>
                {itemData.priority && <Tag type={!itemData.assignee_resolved && !itemData.resolved ? priorityColor : 'default'}>{itemData.priority}</Tag>}
            </td>
            <td>
                <TaskAssignee itemData={itemData} classes={classes}/>
            </td>
            <td className={classes.action_required}>
                {itemData.note_type_id && actionType?.name}
            </td>
            <td>
                {itemData.due_date ? <div className='flex-container flex-container-end gap-5'>
                    {formatDateLocal(itemData.due_date)}
                    {/* {(!itemData.assignee_resolved && !itemData.resolved) && <DaysDifference days={getDaysDifference(itemData.due_date)}/>} */}

                    {!deletedRecord && !itemData.assignee_resolved && !itemData.resolved ?  <>
                        <DaysDifference date={itemData.due_date}/>
                    </> : <>
                        {!deletedRecord && itemData.user?.id === user?.id && !itemData.resolved ? <>
                            <DaysDifference date={itemData.due_date}/>
                        </> : <></>}
                    </>} 
                   
                </div>  : ''}
            </td>
            <td>
                <div className={`${classes.resove_cell} flex-container`}>
                {itemData.is_task ? <>
                        {showResolve ? <>
                            <Button click={openResolveTask} btnStyle={'btn_small'}>Resolve</Button>
                        </> : <></>}

                        {showComplete ? <>
                            <Button click={openResolveTask} btnStyle={'btn_small'}>Complete</Button>
                        </> : <></>}

                        {showResolvedInfo ? <>
                            {itemData.assignee_resolved_by && <>
                                <div>
                                    {formatDateLocal(itemData.assignee_resolved_at)}
                                </div>
                                {itemData.assignee_resolved_by?.name && <div>
                                    <strong>by</strong> {itemData.assignee_resolved_by?.name}
                                </div>}
                            </>}

                            {!itemData.assignee_resolved_by && itemData.resolved_at && <div>
                                {formatDateLocal(itemData.resolved_at)}
                            </div>}
                        </> : null}
                    </> : <></>}
                </div>
            </td>
            <td>
                {!deletedRecord && <div className={classes.row_actions}>
                    <DeleteNote itemData={itemData} caseData={caseData} />
                    <BodySimpleModalV2 normalEvent={true} isFlex={true} messages={[copyMessageText]}>
                        <span className={classes.row_icon_wrap}>
                            <button type='button' className={classes.row_icon_button} onClick={copyTaskMessageHandler} aria-label='Copy note'>
                                <i className="ti ti-copy"></i>
                            </button>
                        </span>
                    </BodySimpleModalV2>
                </div>}
            </td>
        </tr>

        {!deletedRecord && <ResolveAndCreate itemData={itemData} showResolveTask={showResolveTask} setShowResolveTask={() => setShowResolveTask(prevState => !prevState)} isOnDetails={true}/>}

    </>
}

export default NotesItem